import { Action } from 'redux';
import { PreliminaryStateStructure } from '../../angular-elements/shared/interfaces/preliminaryStateStructure.interface';

export class PayloadAction implements Action {
  type: string;
  preliminaryStateStructure?: PreliminaryStateStructure;
}

const INITIAL_STATE: PreliminaryStateStructure = {
  stateCallQuestion: '',
  noLabel: '',
  currentCounty: '',
  planDetails: '',
  dateOfBirth: '',
  reviewInfo: '',
  enrollPerson: '',
};

export const LOAD_PRELIMINARY_INFO = 'LOAD_PRELIMINARY_INFO';
export const INIT_PAYLOAD = 'INIT_PAYLOAD';
const RESET_STATE = 'RESET_STATE_Preliminary';

export function loadPreliminaryInfo(info: PreliminaryStateStructure): PayloadAction {
  return {
    type: LOAD_PRELIMINARY_INFO,
    preliminaryStateStructure: info
  };
}

export function resetPreliminaryInfo(): PayloadAction {
  return { type: RESET_STATE };
}

export function preliminary(state: PreliminaryStateStructure = INITIAL_STATE, action: PayloadAction) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case LOAD_PRELIMINARY_INFO:
      copiedState.stateCallQuestion = action.preliminaryStateStructure.stateCallQuestion;
      copiedState.noLabel = action.preliminaryStateStructure.noLabel;
      copiedState.currentCounty = action.preliminaryStateStructure.currentCounty;
      copiedState.planDetails = action.preliminaryStateStructure.planDetails;
      copiedState.dateOfBirth = action.preliminaryStateStructure.dateOfBirth;
      copiedState.reviewInfo = action.preliminaryStateStructure.reviewInfo;
      copiedState.enrollPerson = action.preliminaryStateStructure.enrollPerson;
      return Object.assign({}, state, copiedState);
    case RESET_STATE:
      return INITIAL_STATE;
    case INIT_PAYLOAD:
    default:
      return state;
  }
}

